{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/DOLOPLUS2",
	"name": "DOLOPLUS-2",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Doloplus-2",
	"purpose": "Gedragsmatige pijnbeoordeling",
	"description": "Een score 0 staat voor normale gedragingen, waarbij een score 3 een hoge mate van pijngerelateerd gedrag aangeeft. De score kan variëren tussen 0 en 30. De totale score geeft geen pijnscore weer van een specifiek moment, maar eerder de progressie van de waargenomen pijn.",
	"item": [
		{
			"type": "group",
			"linkId": "20100",
			"text": "Lichamelijke reacties",
			"item": [
				{
					"linkId": "20200",
					"prefix": "1",
					"text": "Lichamelijke klachten",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20201",
								"display": "Geen klachten"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20202",
								"display": "Klachten alleen bij navraag"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20203",
								"display": "Spontane klachten die af en toe voorkomen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20204",
								"display": "Spontane klachten die voortdurend aanhouden"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20300",
					"prefix": "2",
					"text": "Pijnvermijdende lichaamshouding in rust",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20301",
								"display": "Geen pijnvermijdende lichaamshouding"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20302",
								"display": "Patiënt vermijdt af en toe bepaalde lichaamshoudingen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20303",
								"display": "Permanente doeltreffende pijnvermijdende lichaamshouding"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20304",
								"display": "Permanente niet doeltreffende pijnvermijdende lichaamshouding"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20400",
					"prefix": "3",
					"text": "Afscherming van pijnlijke plaatsen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20401",
								"display": "Geen afscherming"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20402",
								"display": "Afscherming bij toenadering, zonder dat voortzetting van het onderzoek of verzorging wordt belemmerd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20403",
								"display": "Afscherming bij toenadering met belemmering van het onderzoek of verzorging"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20404",
								"display": "Afscherming in rust, ook wanneer er geen toenadering plaats vindt"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20500",
					"prefix": "4",
					"text": "Gelaatsuitdrukking",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20501",
								"display": "Normale gelaatsuitdrukking"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20502",
								"display": "Pijnlijke gelaatsuitdrukking bij toenadering"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20503",
								"display": "Pijnlijke gelaatsuitdrukking ook zonder toenadering"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20504",
								"display": "Voortdurend ongebruikelijke uitdrukkingsloze gelaatsuitdrukking (stil, verstard, lege blik)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20600",
					"prefix": "5",
					"text": "Slaappatroon",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20601",
								"display": "Normaal slaappatroon"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20602",
								"display": "Problemen met inslapen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20603",
								"display": "Vaak wakker worden (onrust)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20604",
								"display": "Slapeloosheid met als gevolg slaperigheid overdag"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				}
			]
		},
		{
			"type": "group",
			"linkId": "20700",
			"text": "Psychomotorische reacties",
			"item": [
				{
					"linkId": "20800",
					"prefix": "6",
					"text": "Verzorgen en aankleden",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20801",
								"display": "Geen verandering in gebruikelijke mogelijkheden"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20802",
								"display": "Gebruikelijke mogelijkheden zijn beperkt (verzorgen en/of aankleden is moeilijk maar wel volledig mogelijk)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20803",
								"display": "Gebruikelijke mogelijkheden zijn zeer beperkt (verzorgen en/of aankleden is moeilijk en maar gedeeltelijk mogelijk)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20804",
								"display": "Verzorgen en/of aankleden is onmogelijk, de patiënt verzet zich bij elke poging"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20900",
					"prefix": "7",
					"text": "Bewegingen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20901",
								"display": "Geen verandering in gebruikelijke mogelijkheden"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20902",
								"display": "Gebruikelijke actieve mogelijkheden zijn beperkt (patiënt vermijdt bepaalde bewegingen en vermindert loopafstanden)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20903",
								"display": "Gebruikelijke actieve en passieve mogelijkheden zijn beperkt (zelfs met hulp vermindert de patiënt zijn bewegingen)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20904",
								"display": "Iedere beweging onmogelijk, verzet zich tegen elke poging tot mobilisatie"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				}
			]
		},
		{
			"type": "group",
			"linkId": "21000",
			"text": "Psychosociale reacties",
			"item": [
				{
					"linkId": "21100",
					"prefix": "8",
					"text": "Communicatie",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "21101",
								"display": "Onveranderd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "21102",
								"display": "Toegenomen (de patiënt trekt de aandacht op een ongebruikelijke manier)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "21103",
								"display": "Verminderd (de patiënt isoleert zich, zondert zich af)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "21104",
								"display": "Afwezigheid van of weigering van elke vorm van communicatie"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "21200",
					"prefix": "9",
					"text": "Sociale activiteiten",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "21201",
								"display": "Gebruikelijke deelname aan verschillende activiteiten (maaltijden, ontspanning, therapeutische activiteiten, etc.)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "21202",
								"display": "Deelname aan verschillende activiteiten alleen als men erom vraagt"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "21203",
								"display": "Gedeeltelijke weigering om aan verschillende activiteiten deel te nemen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "21204",
								"display": "Alle sociale contacten worden geweigerd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "21300",
					"prefix": "10",
					"text": "Gedragsproblemen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "21301",
								"display": "Normaal gedrag"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "21302",
								"display": "Herhaalde gedragsproblemen bij toenadering"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "21303",
								"display": "Permanente gedragsproblemen bij toenadering"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "21304",
								"display": "Permanente gedragsproblemen (zonder aanleiding/ externe stimulus)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				}
			]
		}
	]
}
